<template>
  <div class="form">
    <div class="grid-container" v-if="status == 1">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-12 cell">
          <h2 class="form__title">Fale connosco e saiba mais.</h2>
          <p class="form__subtitle">
            Preencha os seus dados e nós contactamos:
          </p>
        </div>
        <div class="small-12 cell">
          <div class="form-group">
            <label for="name">Nome*</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Primeiro e último nome"
              class="form__input"
              v-model="form.CustomerName"
              v-validate="'required|validname'"
              data-vv-as="Nome"
            />
            <span class="error" v-if="errors.first('name')">{{
              errors.first("name")
            }}</span>
          </div>

          <div class="form-group">
            <label for="email">Email*</label>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="email@dominio.com"
              class="form__input"
              v-model="form.CustomerEmail"
              v-validate="'required|email'"
              data-vv-as="Email"
            />
            <span class="error" v-if="errors.first('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="form-group">
            <label for="phone">Telemóvel*</label>
            <input
              type="text"
              name="phone"
              id="phone"
              placeholder="ex: 910000000"
              class="form__input"
              v-model="form.CustomerPhone"
              v-validate="'required|min:9|max:9|validphone:9'"
              data-vv-as="Telemóvel"
              v-mask="'#########'"
            />
            <span class="error" v-if="errors.first('phone')">{{
              errors.first("phone")
            }}</span>
          </div>
        </div>
        <div class="small-12 cell">
          <div class="rgpd">
            <h3 class="rgpd__text">
              <strong>Por que precisamos dos seus dados?</strong>
            </h3>
            <p class="rgpd__text">
              Os dados pessoais por si acima facultados serão tratados para
              realizar a presente simulação e fazer o acompanhamento comercial
              subsequente da mesma. Se nos der o seu consentimento, iremos
              também usar a sua informação para envio de comunicações relativas
              a produtos e serviços da Companhia que poderão ser do seu
              interesse. Recordamos-lhe que tem o direito de retirar o seu
              consentimento a qualquer momento. Os seus dados nunca serão
              utilizados por terceiros ou entidades externas à Fidelidade.
            </p>
            <p class="rgpd__text">
              <a
                class="rgpd__link"
                href="https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf"
                target="_blank"
                >Consulte aqui, informação mais detalhada sobre protecção e
                tratamento dos seus dados pela Fidelidade.</a
              >
            </p>
            <button
              type="button"
              class="btn btn__text form__btn"
              @click="submitPreRequest"
              :disabled="btnDisable"
            >
              QUERO SER CONTACTADO
            </button>
            <span
              class="backenderror"
              style="display: block"
              v-for="(error, index) in consoleErrors"
              :key="index"
              >{{ error[0] }}<br
            /></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Page -->
    <div class="grid-container" v-if="status == 2">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Obrigado pela sua confiança.</h4>
          <img
            src="../../assets/icon-thanks.svg"
            alt="Obrigado"
            width="60"
            height="60"
            class="form-success__img"
            style="margin: 20px 0"
          />
          <p class="form-success__text">
            <strong>Os seus dados foram submetidos com sucesso.</strong>
            <br />
            Em breve, será contactado por um agente Fidelidade.
          </p>
        </div>
      </div>
    </div>

    <!-- Already Submited Page -->
    <div class="grid-container" v-if="status == 3">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Obrigado pela sua confiança.</h4>
          <img
            src="../../assets/icon-thanks.svg"
            alt="Obrigado"
            width="60"
            height="60"
            class="form-success__img"
            style="margin: 20px 0"
          />
          <p class="form-success__text">
            <strong
              >O NIF indicado já se encontra registado para esta ação. Se
              necessitar de ajuda contacte-nos.</strong
            >
          </p>
        </div>
      </div>
    </div>

    <!-- Error processing Lead -->
    <div class="grid-container" v-if="status == 4">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Ups.</h4>
          <img
            src="../../assets/icon-thanks.svg"
            alt="Obrigado"
            width="60"
            height="60"
            class="form-success__img"
            style="margin: 20px 0"
          />
          <p class="form-success__text">
            <strong
              >Os seus dados não foram submetidos. Por favor tente
              novamente.</strong
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import pt from "vee-validate/dist/locale/pt_PT";
import VeeValidate, { Validator } from "vee-validate";
import VueTheMask from "vue-the-mask";
import axios from "axios";
import validateVAT from "../LeadStore/validations/vat";
import validateNAME from "../LeadStore/validations/name";
import validatePHONE from "../LeadStore/validations/phone";

Vue.prototype.$http = axios;

Vue.use(VeeValidate);
Vue.use(VueTheMask);

Validator.localize("pt", pt);

function getParameterByName(name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default {
  props: ["openForm"],
  data() {
    return {
      status: 1,
      consoleErrors: null,
      btnDisable: false,
      form: {
        CustomerName: null,
        CustomerEmail: null,
        CustomerPhone: null,
        utm_campaign: null,
        utm_source: null,
        utm_medium: null,
        utm_content: null,
        utm_term: null,
      },
    };
  },
  mounted() {
    this.form.utm_campaign = getParameterByName("utm_campaign");
    this.form.utm_source = getParameterByName("utm_source");
    this.form.utm_medium = getParameterByName("utm_medium");
    this.form.utm_content = getParameterByName("utm_content");
    this.form.utm_term = getParameterByName("utm_term");
  },
  created() {
    this.$validator.extend("validvat", validateVAT);
    this.$validator.extend("validname", validateNAME);
    this.$validator.extend("validphone", validatePHONE);
  },
  methods: {
    submitPreRequest: function () {
      this.btnDisable = true;
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.submitted = true;
          _this.$http
            .post(
              "https://fidelidade.caetsudigital.com/api/custom/store-form-json",
              { category: "acidentes-trabalho", content: _this.form }
            )
            .then((response) => {
              if (response.data.nif) {
                _this.status = 3;
              } else {
                if (response.data.status) {
                  window.dataLayer.push({ event: "ajaxLSSuccess" });
                  _this.status = 2; // Show Success
                } else {
                  _this.status = 4; // Show Error
                }
              }
            })
            .catch((error) => {
              console.log(error);
              _this.consoleErrors = error.response.data.errors;
            });
        }
      });

      this.btnDisable = false;
    },
  },
};
</script>
